import { createApiCall } from '../../../services/apiClient';
import type { ChatRereadingSettings } from './settingsTypes';

/**
 * The rereading intervention settings. The API stores them in metadata_private/chat_rereading
 * and gives the defaults for fields that are not saved.
 */
export const chatRereadingSettingsService = {
  getSettings: createApiCall<void, ChatRereadingSettings>('getChatRereadingSettings'),
  saveSettings: createApiCall<ChatRereadingSettings, ChatRereadingSettings>('adminUpdateChatRereadingSettings'),
};
